export const DEFAULT_CONFIG = {
  name_config: "",
  selected_fields: ["autor", "medio"],
  separator: ",",
  wrapper_start: "(",
  wrapper_end: ")",
  prefix: "",
  suffix: "",
  alignment: "LEFT",
  layout: "CONCATENATED",
  list_type: "NONE",
  flg_active: 1,
};

export const WRAPPER_PAIRS = {
  "(": ")",
  "{": "}",
  "[": "]",
  "": "",
};

export const WRAPPER_OPTIONS = [
  { value: "(", label: "Paréntesis  ( )" },
  { value: "{", label: "Llaves  { }" },
  { value: "[", label: "Corchetes  [ ]" },
  { value: "", label: "Sin envoltorio" },
];

export const SEPARATOR_OPTIONS = [
  { value: "-", label: "Guión  ( - )" },
  { value: "*", label: "Asterisco  ( * ) " },
  { value: "/", label: "Diagonal  ( / ) " },
  { value: "|", label: "Barra vertical  ( | ) " },
  { value: ",", label: "Coma  ( , ) " },
  { value: "~", label: "Tilde  ( ~ ) " },
];

export const ALIGNMENT_OPTIONS = [
  { value: "LEFT", label: "Izquierda" },
  { value: "CENTER", label: "Centro" },
  { value: "RIGHT", label: "Derecha" },
  { value: "JUSTIFIED", label: "Justificado" },
];

export const AVAILABLE_FIELDS = [
  { key: "autor", label: "Autor" },
  { key: "type_medio", label: "Tipo de Medio" },
  { key: "medio", label: "Medio" },
  { key: "pagina", label: "Página" },
  { key: "hora", label: "Hora" },
  { key: "fecha", label: "Fecha" },
];

export const PREVIEW_WITNESSES = [
  { medio: "La Jornada", autor: "Redacción." },
  { medio: "El Universal", autor: "Redacción" },
];